import React from 'react';
import { useHistory } from 'react-router-dom';

import AppBar from 'components/AppBar';
import ProgressSteps from 'components/ProgressSteps';

import { RegistrationOnboardingLayoutProps } from '..';

import { Container, Content, ContentScroll, ProgressContainer } from './styles';

const RegistrationOnboardingMobileLayout = ({
  children,
  totalSteps,
  currentStep,
  noGoBack,
  onGoBack,
  appBarTitle,
}: RegistrationOnboardingLayoutProps) => {
  const history = useHistory();

  const handleGoBack = () => {
    if (onGoBack) onGoBack();
    else history.goBack();
  };

  return (
    <Container>
      {appBarTitle && (
        <AppBar goBack={handleGoBack} noGoBack={noGoBack} noShadow>
          {appBarTitle}
        </AppBar>
      )}

      {currentStep !== undefined && (
        <ProgressContainer>
          <ProgressSteps size={totalSteps || 1} currentStep={currentStep} />
        </ProgressContainer>
      )}

      <Content>
        <ContentScroll>{children}</ContentScroll>
      </Content>
    </Container>
  );
};

export default RegistrationOnboardingMobileLayout;
